<script>
import ViewTitle from '@/components/ViewTitle'
import ViewDescription from '@/components/ViewDescription'
import PincodeInput from '@/components/PincodeInput'
import Button from '@/components/Button'
import LoyaltyCardsServices from '@/services/loyaltyCards'
import EnvironmentUtils from '@/utils/environmentUtils'

export default
{
    name: 'loyalty-edit-card-scan-manual',

    render () 
    {
        return (
            <div id='loyalty-edit-card-scan-manual-view'>
                <view-title back-action={() => this.$router.back}>Entrer le code client manuellement</view-title>
                <view-description>Le code client est situé en dessous du nom du titulaire de la carte de fidélité</view-description>
                <pincode-input length={8} digits-per-row={4} allow-alphabeticals={false} allow-numerals={true} v-model={this.cardId}
                    on-pin-complete={this.onPinComplete} autofocus={true} ref='pincode' />
                <Button text='Continuer' on-click={this.onPinComplete} type='primary' />
            </div>
        )
    },

    data () 
    {
        return {
            cardId: ''
        }
    },

    mounted ()
    {
    },

    methods:
    {
        async onPinComplete ()
        {
            try
            {
                await LoyaltyCardsServices.fetchCard(EnvironmentUtils.cityId, this.$store.state.user.token, this.cardId)
                this.$router.push({ name: 'LoyaltyCardEditCreditPoints', params: {cardId: this.cardId} })
            }
            catch (e)
            {
                this.$refs.pincode.setErrorMessage('Aucune carte de fidélité associée à ce numéro n\'a pu être trouvée')
            }
        }
    },

    components:
    {
        PincodeInput,
        ViewTitle,
        ViewDescription,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-edit-card-scan-manual-view
{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 10px;
    margin-right: 10px;

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .button
    {
        width: -webkit-fill-available;
        margin-top: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardEditScanManual.vue